module.exports = __webpack_public_path__ + "static/media/zhaoyu.a3c810a2.png";